import { computed } from "mobx";
import { inject, observer } from "mobx-react";

import Default from "./Default";

const InputTextUi = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = computed(() => mainStore.getMainStore("init")).get();
        let Specified = Default;

        for (const key in abTests) {
            const ver = init?.data?._ab_m?.[key]?._d?.colorHeader;
            if (ver === "v2") {
                Specified = abTests[key];
                break;
            }
        }

        if (props.noAb) Specified = Default;

        return <Specified {...props} />;
    }),
);

const abTests = {};

export default InputTextUi;
